const closeWebview = history => {
  if (window.flutter_inappwebview) {
    window.flutter_inappwebview.callHandler('exitWebview', []);
  } else if (window.Android?.closeWebView) {
    window.Android?.closeWebView();
  } else {
    history.push('/');
  }
};

export default closeWebview;
